import React from 'react';
import { 
  Typography, 
  Container, 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  TextField, 
  Button, 
  Divider,
  Paper
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const Contact = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          İletişim
        </Typography>
        <Typography variant="h6" paragraph align="center" color="text.secondary">
          Projenizi veya sorularınızı bizimle paylaşın
        </Typography>
        <Divider sx={{ my: 4 }} />
      </Box>

      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            Bize Yazın
          </Typography>
          <Paper elevation={3} sx={{ p: 3 }}>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="firstName"
                    name="firstName"
                    label="Ad"
                    fullWidth
                    autoComplete="given-name"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="lastName"
                    name="lastName"
                    label="Soyad"
                    fullWidth
                    autoComplete="family-name"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="email"
                    name="email"
                    label="E-posta Adresi"
                    fullWidth
                    autoComplete="email"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="company"
                    name="company"
                    label="Şirket"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="subject"
                    name="subject"
                    label="Konu"
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="message"
                    name="message"
                    label="Mesajınız"
                    fullWidth
                    multiline
                    rows={4}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary" 
                    size="large"
                    fullWidth
                  >
                    Gönder
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Typography variant="h5" gutterBottom>
            İletişim Bilgileri
          </Typography>
          <Card elevation={3} sx={{ mb: 4, height: 'calc(100% - 64px)' }}>
            <CardContent sx={{ height: '100%' }}>
              <Grid container spacing={3} sx={{ height: '100%' }}>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                    <LocationOnIcon color="primary" sx={{ mr: 2, fontSize: 30 }} />
                    <Box>
                      <Typography variant="h6">Adres</Typography>
                      <Typography variant="body1">
                        Levent Mahallesi, Büyükdere Caddesi No:123<br />
                        34394 Şişli/İstanbul
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                    <PhoneIcon color="primary" sx={{ mr: 2, fontSize: 30 }} />
                    <Box>
                      <Typography variant="h6">Telefon</Typography>
                      <Typography variant="body1">
                        +90 (212) 123 45 67
                      </Typography>
                      <Typography variant="body1">
                        +90 (212) 123 45 68
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <EmailIcon color="primary" sx={{ mr: 2, fontSize: 30 }} />
                    <Box>
                      <Typography variant="h6">E-posta</Typography>
                      <Typography variant="body1">
                        info@dcatanalytics.com
                      </Typography>
                      <Typography variant="body1">
                        satis@dcatanalytics.com
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                
                <Grid item xs={12} sx={{ mt: 'auto' }}>
                  <Typography variant="h6" gutterBottom>
                    Çalışma Saatleri
                  </Typography>
                  <Typography variant="body1">
                    Pazartesi - Cuma: 09:00 - 18:00<br />
                    Cumartesi - Pazar: Kapalı
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 6, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Konum
        </Typography>
        <Paper elevation={3} sx={{ height: '400px', width: '100%' }}>
          <Box
            component="iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12037.823534422!2d28.990873366235538!3d41.074387594095855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab6aabd793481%3A0xa94f52f718bdf5a1!2sLevent%2C%20%C5%9Ei%C5%9Fli%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1635774532142!5m2!1str!2str"
            sx={{ border: 0, width: '100%', height: '100%' }}
            allowFullScreen
            loading="lazy"
          />
        </Paper>
      </Box>
    </Container>
  );
};

export default Contact;
